/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener('DOMContentLoaded', function() {
	const printButtons = document.querySelectorAll('.print-calendar-button');

	printButtons.forEach(function(button) {
		button.addEventListener('click', function(event) {
			event.preventDefault();

			// Find the iframe with the class 'port-schedule'
			const iframe = document.querySelector('.port-schedule');

			if (iframe && iframe.src) {
				// Open the iframe URL in a new window
				const printWindow = window.open(iframe.src, '_blank');

				if (printWindow) {
					// Wait until the new window has finished loading its content
					printWindow.addEventListener('load', function() {
						printWindow.focus();
						printWindow.print();
					});
				} else {
					console.error('Unable to open new window for printing.');
				}
			} else {
				console.error('No iframe found with the class "port-schedule", or the iframe has no src.');
			}
		});
	});
});
